import { Box, Flex, Icon, Text } from "@chakra-ui/react";
import { Logo } from "ui";

interface MobileNotSupportedProps {
  exchangeInfo?: React.ReactNode;
}

const MobileNotSupported = ({ exchangeInfo }: MobileNotSupportedProps) => {
  return (
    <>
      <Flex alignItems="center" gap="0.5rem" pt="2rem" pl="1rem" mb="2rem">
        <Icon as={Logo} />
        <Text fontSize="1.5rem" color="brand.textColor" fontWeight="600">
          Stader
        </Text>
      </Flex>
      {exchangeInfo && (
        <Box
          m="1rem"
          px="1.5rem"
          bgColor="brand.backgroundLight"
          borderRadius="1rem"
        >
          {exchangeInfo}
        </Box>
      )}
      <Box
        m="1rem"
        px="1.5rem"
        py="1.2rem"
        bgColor="brand.backgroundLight"
        borderRadius="1rem"
        textAlign="center"
      >
        <Box fontSize="1.5rem" fontWeight={600} pb="1rem">
          Hi there, welcome to the Stader community :)
        </Box>
        <Box>
          Stader is currently only available on Desktop, please access the Dapp
          on desktop. We will be adding a mobile version soon.
        </Box>
      </Box>
    </>
  );
};

export default MobileNotSupported;
